/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 function openTab(evt, tabTarget) {

    var i, tabcontent, tablinks;

    tabcontent = document.getElementsByClassName("rns_tab--content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablinks = document.getElementsByClassName("rns_tab--btn");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    document.getElementById(tabTarget).style.display = "block";
    evt.currentTarget.className += " active";
}

////////////////////////////////
// Set filter tag in button
///////////////////////////////

var tags = document.querySelectorAll('[data-action=toggle-tag]'),
    resetBtn = document.querySelector('[data-action=reset-tags]'),
    activeTags = document.querySelectorAll('.rns_active_tag'),
    noTags = document.querySelectorAll('.rns_no_filter_tag');

for ( i=0; i < tags.length; i++){
    var label, target1, target2;

    label = tags[i].innerHTML;
    targetParent = tags[i].closest('.Collapsible');
    target1 = targetParent.querySelector(".Collapsible__Button .rns_no_filter_tag");
    target2 = targetParent.querySelector(".Collapsible__Button .rns_active_tag");

    if(tags[i].classList.contains('is-active')){
        target1.style.display = "none";
        target2.style.display = "inline";
        target2.innerHTML = label;
    }

    tags[i].addEventListener("click",function(f){
        return function(event){
            label = this.innerHTML;
            targetParent = this.closest('.Collapsible');
            target1 = targetParent.querySelector(".Collapsible__Button .rns_no_filter_tag");
            target2 = targetParent.querySelector(".Collapsible__Button .rns_active_tag");
            if(this.classList.contains('is-active')){
                target1.style.display = "inline";
                target2.style.display = "none";
                target2.innerHTML = '';
            }else{
                target1.style.display = "none";
                target2.style.display = "inline";
                target2.innerHTML = label;
            }
        };

    }(i));
}

function rnsReset(){
    for ( j=0; j < activeTags.length; j++){
        activeTags[j].innerHtml = "";
        activeTags[j].style.display = "none";
        noTags[j].style.display = "inline";
    };
}

//////////////////////////
// Login drawer
/////////////////////////


function toggleSideLogin(){
    var sidebarLogin = document.getElementById('sidebar-login'),
        overlay = document.querySelector('.PageOverlay'),
        html = document.documentElement,
        height = window.innerHeight;

    sidebarLogin.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));

    if ( sidebarLogin.getAttribute('aria-hidden') === 'true'){
        sidebarLogin.setAttribute('aria-hidden', 'false');
        overlay.classList.add('is-visible');
        html.classList.add('no-scroll');
        sidebarLogin.style.maxHeight = height + 'px';
    }else{
        sidebarLogin.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('is-visible');
        html.classList.remove('no-scroll');
    }
}
